export const START_APPLICATION_BUTTON_CONSTANTS = {
	DEFAULT_BUTTON_TEXT: 'New Application'
};
